module.exports = __webpack_public_path__ + "img/Cube_qui_avance.d1b46e19.gif";